var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48667 0 0 4.51778 0 10.0722C0 17.9644 9.06 26.1133 9.44556 26.4556C9.59795 26.592 9.79525 26.6675 9.99979 26.6677C10.2043 26.6679 10.4018 26.5928 10.5544 26.4567C10.94 26.1133 20 17.9644 20 10.0722C20 4.51778 15.5133 0 10 0ZM10 15.5556C6.93667 15.5556 4.44444 13.0633 4.44444 10C4.44444 6.93667 6.93667 4.44445 10 4.44445C13.0633 4.44445 15.5556 6.93667 15.5556 10C15.5556 13.0633 13.0633 15.5556 10 15.5556Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.662b56be64b871352a92a0ca15355a9b.svg";
export { ForwardRef as ReactComponent };